import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { useNavigate, useParams } from "react-router-dom";
import image from "../../../Assets/image.png";
import CancelModel from "./cancelOrder";
import swal from "sweetalert";
import BookingInfo from "./BookingInfo";
import OfferInfo from "./offerInfo";
function Products() {
    const Navigate = useNavigate();
    const { id, type } = useParams();
    const [returnMododal, setReturnModal] = useState(false);
    const [allVendorData, setAllvendors] = useState([]);

    const [cancelModel, setcancelmodel] = useState(false);
    let [loading, setLoading] = useState(true);
    const [status, setStatus] = useState();
    const [orders, setOrders] = useState([]);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };

    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const getorders = () => {
        setLoading(true);
        Services.BookingDetails("GET", null, token, id, type)
            .then((res) => {
                console.log(res);
                setLoading(false);
                if (res.Status === 1) {
                    setOrders(res.Booking);
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const allVendors = () => {
        Services.allVendors("GET", null, token)
            .then((res) => {
                console.log(res);
                if (res.Status === 1) {
                    setAllvendors(
                        res.Vendors?.filter((item) => item.status == "Active")
                    );
                    console.log(
                        res.Vendors?.filter((item) => item.status == "Active")
                    );
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getorders();
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (status) {
            statusHandler();
        }
    }, [status]);
    const cancelOrder = () => {
        swal("Are You sure you want to Cacenl Order?", {
            icon: "warning",
            className: dashboardclasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "No",
                catch: {
                    text: "Cancel",
                    value: "Delete",
                    className: dashboardclasses[".cancel-delete"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    setLoading(false);

                    Services.updateBooking(
                        "POST",
                        JSON.stringify({
                            booking_id: orders?.booking_id,
                            status: 6,
                        }),
                        token,
                        id
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                getorders();
                                setLoading(true);
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                setLoading(false);

                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            setLoading(false);
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    const dateformatter = (cell) => {
        const date = new Date(cell);

        return (
            <p>
                <Moment format="MMMM Do YYYY hh:mm a" utc>
                    {date}
                </Moment>
            </p>
        );
    };

    const orderstatusformatter = (cell) => {
        //eslint-disable-next-line
        if (cell == "3") {
            return (
                <div
                    style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        justifySelf: "right",
                        gap: "0.5rem",
                    }}>
                    <div
                        className={`${
                            dashboardclasses[`order-delivered-wrapper`]
                        } ${dashboardclasses[`order-status-wrapper`]}`}>
                        <p className={dashboardclasses["order-delivered"]}>
                            Completed
                        </p>
                    </div>
                </div>
            );
        }
        if (cell == "1") {
            return (
                <>
                    <div
                        style={{
                            display: "grid",
                            alignItems: "center",
                            justifyItems: "center",
                            justifySelf: "right",
                            gap: "0.5rem",
                        }}>
                        <div
                            className={`${
                                dashboardclasses[`order-delivered-wrapper`]
                            } ${dashboardclasses[`order-status-wrapper`]}`}>
                            <p className={dashboardclasses["order-delivered"]}>
                                Pending
                            </p>
                        </div>
                    </div>
                    <button
                        style={{ color: "white", background: "red" }}
                        onClick={cancelOrder}>
                        {" "}
                        Cancel Booking
                    </button>
                </>
            );
        }

        if (cell == "2") {
            return (
                <div
                    className={`${dashboardclasses[`order-returned-wrapper`]} ${
                        dashboardclasses[`order-status-wrapper`]
                    }`}>
                    <p>Ongoing</p>
                </div>
            );
        }
        if (cell == "4") {
            return (
                <div
                    className={`${dashboardclasses[`order-returned-wrapper`]} ${
                        dashboardclasses[`order-status-wrapper`]
                    }`}>
                    <p>Cancelled</p>
                </div>
            );
        }
        if (cell == "5") {
            return (
                <div
                    className={`${dashboardclasses[`order-returned-wrapper`]} ${
                        dashboardclasses[`order-status-wrapper`]
                    }`}>
                    <p> Expired</p>
                </div>
            );
        }
        //eslint-disable-next-line
        if (cell == "Payment-Failed") {
            return (
                <div className={dashboardclasses[`cancel-wrapper`]}>
                    <p className={dashboardclasses["cancel"]}>
                        Payment-Failed{" "}
                    </p>
                </div>
            );
        } else {
            return (
                <div
                    className={`${dashboardclasses[`order-pending-wrapper`]} ${
                        dashboardclasses[`order-status-wrapper`]
                    }`}>
                    <p>{cell}</p>
                </div>
            );
        }
    };

    const statusHandler = (e) => {
        setLoading(true);
        let body = {
            status: status,
            type: "service",
        };
        Services.updateOrderStatus("POST", JSON.stringify(body), token, id)
            .then((res) => {
                if (res.Status === 1) {
                    getorders();
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // setOrdersSearch(res.Orders);
                } else if (res.Status === 0) {
                    setLoading(false);
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    return (
        <>
            {cancelModel && (
                <CancelModel
                    setmodal={setcancelmodel}
                    id={id}
                    getorders={getorders}
                    setLoading={setLoading}
                />
            )}
            {/* {returnMododal && (
                <ReturnModal
                    setmodal={setReturnModal}
                    orders={orders}
                    getorders={getorders}
                />
            )} */}

            <Layout Active={"mobility_Bookings"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                {type == "booking" ? (
                                    <BookingInfo
                                        dateformatter={dateformatter}
                                        orders={orders}
                                        id={id}
                                        orderstatusformatter={
                                            orderstatusformatter
                                        }
                                    />
                                ) : (
                                    <OfferInfo
                                        dateformatter={dateformatter}
                                        orders={orders}
                                        orderstatusformatter={
                                            orderstatusformatter
                                        }
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
